class ESCAccordionCustom extends HTMLElement {

    /** @type {HTMLDetailsElement} */
    get details() {
		const details = this.querySelector('details');

		if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');

		return details;
	}

    /** @type {HTMLElement} */
    get summary() {
		const summary = this.details.querySelector('summary');

		if (!(summary instanceof HTMLElement)) throw new Error('Summary element not found');

		return summary;
    }

    #controller = new AbortController();

    connectedCallback() {
		const { signal } = this.#controller;

		this.#setDefaultOpenState();
    }

    /**
     * Handles the disconnect event.
     */
    disconnectedCallback() {
		// Disconnect all the event listeners
		this.#controller.abort();
    }

    /**
     * Sets the default open state of the accordion based on the `open-by-default` attribute.
     */
    #setDefaultOpenState() {
      	this.details.open = this.hasAttribute('open-by-default');
    }
}

if (!customElements.get('esc-accordion-custom')) {
  	customElements.define('esc-accordion-custom', ESCAccordionCustom);
}
